import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LoaderService {
  // Internal subjects for the loading state and progress value.
  private _isLoading = new BehaviorSubject<boolean>(false);
  private _progress = new BehaviorSubject<number>(0);

  // Exposed observables for component/template binding.
  isLoading$: Observable<boolean> = this._isLoading.asObservable();
  progress$: Observable<number> = this._progress.asObservable();

  // Hold timer reference for the simulated progress.
  private progressInterval: any;

  // Signal the start of a loading operation.
  startLoading(): void {
    this._isLoading.next(true);
    this._progress.next(0);
  }

  // Update progress externally.
  updateProgress(value: number): void {
    this._progress.next(value);
  }

  // Stop the loading operation.
  stopLoading(): void {
    this._isLoading.next(false);
    this._progress.next(0);
  }

  /**
   * Simulates gradual progress updates.
   *
   * @param initial   The starting progress (default is 50).
   * @param target    The maximum simulated progress (default is 90).
   * @param step      How much to increase per interval (default is 2).
   * @param interval  Update interval in milliseconds (default is 100ms).
   */
  startSimulatedProgress(initial = 50, target = 90, step = 2, interval = 100): void {
    this._progress.next(initial);
    this.progressInterval = setInterval(() => {
      const currentProgress = this._progress.getValue();
      const nextProgress = Math.min(currentProgress + step, target);
      this._progress.next(nextProgress);
    }, interval);
  }

  /**
   * Clears the simulated progress timer.
   */
  stopSimulatedProgress(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }
}